import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        paddingTop: 0
    },
    rootTable: {
        width: 'calc(100% - 30px)', borderCollapse: 'inherit', borderSpacing: 0,
    },
    trTable: {
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
            background: 'rgba(255,255,255, 0.15)'
        }
    },
    wrap: {
        padding: 0, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    wrapBlock: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    search: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        borderRadius: 4,
        color: '#fff',
        outline: 'none',
        margin: '10px 0',
        width: '97.3%'
    },
    colorFFF: {
        color: '#fff',
    },
    divider: {
        height: 1, 
        background: 'rgb(176, 176, 176)', 
        marginTop: 12
    },
    wrapSwitch: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165,
    },
    manually: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165, 
        color: '#fff'
    },
    spo: {
        width: 40, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#141b33',
        color: '#fff',
        boxShadow: '4px 4px 8px 0px rgb(34 60 80 / 20%)',
    },
    datetime: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff'
    },
    text: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff',
        height: 36,
        width: 149
    },
}));

const columns = [
    { id: 'groups', label: 'Группа'},
    { id: 'in', label: 'Вход'},
    { id: 'out', label: 'Выход'},
    { id: 'difference', label: 'Разница(входа и выхода)'},
    { id: 'air_in', label: 'Вход(Воздух)'},
    { id: 'air_out', label: 'Выход(Воздух)'},
    { id: 'result_air', label: 'Разница (воздух)'}
];

const getRow = (shift) => {
    return  shift.data.map((item) => {
        return {
            groups: item.groups,
            in: new Intl.NumberFormat('ru-RU').format(item.sum_deposit) + '₽',
            out: new Intl.NumberFormat('ru-RU').format(item.sum_withdrawal ? item.sum_withdrawal : 0) + '₽',
            difference: new Intl.NumberFormat('ru-RU').format(item.sum_deposit - item.sum_withdrawal) + '₽',
            air_in:  new Intl.NumberFormat('ru-RU').format(item.sum_air) + '₽',
            air_out: new Intl.NumberFormat('ru-RU').format(item.sum_air_withdrawal) + '₽',
            result_air: new Intl.NumberFormat('ru-RU').format(item.sum_air - item.sum_air_withdrawal) + '₽',
        }
    })
}

export {
    useStyles,
    columns,
    getRow
}